
export const round = (value: number) => {
    return Math.round(value * 1000) / 1000;
};

export const manhattanDistance = (point1: number[], point2: number[]) => {
    if (point1.length !== point2.length) {
        throw new Error('Points must have the same number of dimensions.');
    }

    let distance = 0;
    for (let i = 0; i < point1.length; i++) {
        distance += Math.abs(point1[i] - point2[i]);
    }

    return distance;
};

export const euclideanDistance = (point1: number[], point2: number[]): number => {
    if (point1.length !== point2.length) {
        throw new Error('Points must have the same number of dimensions.');
    }

    let sumOfSquares = 0;
    for (let i = 0; i < point1.length; i++) {
        const diff = point1[i] - point2[i];
        sumOfSquares += diff * diff;
    }

    return Math.sqrt(sumOfSquares);
};

export const manhattanDistanceExplanation = (point1: number[], point2: number[], isFull = true): string => {
    if (point1.length !== point2.length) {
        throw new Error('Points must have the same number of dimensions.');
    }

    if(!isFull) {
        const parts: string[] = [];
        for (let i = 0; i < point1.length; i++) {
            const str = `|${ point1[i] } - ${ point2[i] }|`;
            parts.push(str);
        }
        return parts.join(' + ');
    }

    const diffs: string[] = [];
    const values: string[] = [];
    let total = 0;

    for (let i = 0; i < point1.length; i++) {
        const rawDiff = Math.abs(point1[i] - point2[i]);
        const diff = Number(round(rawDiff));
        diffs.push(`|${point1[i]}-${point2[i]}|`);
        values.push(round(diff).toString());
        total += diff;
    }

    return `${diffs.join(' + ')} = ${values.join(' + ')} = ${ round(total) }`;
};

export const euclideanDistanceExplanation = (point1: number[], point2: number[], isFull = true): string => {
    if (point1.length !== point2.length) {
        throw new Error('Points must have the same number of dimensions.');
    }

    const diffs: string[] = [];
    const squares: string[] = [];
    let total = 0;

    for (let i = 0; i < point1.length; i++) {
        const diff = point1[i] - point2[i];
        const square = round(Number((diff * diff)));
        diffs.push(`(${point1[i]}-${point2[i]})²`);
        squares.push(round(square).toString());
        total += square;
    }

    let res = `√(${diffs.join(' + ')})`;

    if(isFull) {
        res = res + ` = √(${squares.join(' + ')}) = √(${ round(total) }) = ${ round(Math.sqrt(total)) }`;
    }

    return res;
};

export const getPointString = (point: number[]) => {
    return `(${ point.join(', ') })`;
};

export const getPointKey = (point: number[]) => {
    return point.join('-');
};